import { serverGet } from "lib/serverRequest";

export const getAllRegions = ({ data = {}, onFinish = () => {} }) => {
  serverGet({
    url: "region/all",
    data: data,
    onFinish: onFinish,
  });
};